import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Inner.css";
import "./Eligibility.css";

export default function Eligibility() {
  const [form, setForm] = useState({ email: "", phone: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // DEMO ONLY: in production this would hand off to the partner
    // eligibility-check service and the progress page would poll
    // real status instead of simulating it.
    navigate("/check-eligibility/status", { state: form });
  };

  return (
    <>
      <section className="page-hero eligibility-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: "#F2FAFA" }}>Check Your Eligibility</span>
          <h1>See If You Qualify</h1>
        </div>
      </section>

      <section>
        <div className="container narrow">
          <p>
            Enter your details below and we'll check your eligibility for flexible
            payment options on hearing aids.
          </p>

          <form className="eligibility-form" onSubmit={handleSubmit}>
            <label>
              Email Address
              <input
                type="email"
                name="email"
                required
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
            </label>
            <label>
              Phone Number
              <input
                type="tel"
                name="phone"
                required
                value={form.phone}
                onChange={handleChange}
                placeholder="+234 000 000 0000"
              />
            </label>
            <button type="submit" className="btn btn-primary">Check Eligibility</button>
          </form>
        </div>
      </section>
    </>
  );
}
